import React, { Fragment, useEffect, useState } from "react";
import { Link } from "react-router-dom";
function ProjectsPage() {
    const [projects, setProject] = useState([]);

    
  const fetchProject = async () => {
    try {
      const response = await fetch(`/api/projects`);
      const jsonData = await response.json();
      setProject(jsonData);    
      console.log(projects);
      
        } catch (err) {
          console.error("Error fetching objects:", err);
        }
      };
    
      useEffect(() => {
        fetchProject(); 
      }, []);


return (
<Fragment>
<div className="prj_space">
  <h1>Projects</h1>
  <div className="prj_wrapper">
    {projects.map(project => (
      <Link 
      to={`/project/${project.prj_id}`} >
      <div className="prj_card" key={project.prj_id}>
        <div className="prj_cardcontent">
          <div className="prj_cardmediaspace">
            <img 
              className="prj_cardimg" 
              src={`/api/uploads/${project.prj_img}`} 
              alt={project.prj_img} 
            />
          </div>
          <div className="prj_cardbottom">
            <h3 className="prj_card_title">{project.prj_name}</h3>
            <p className="prj_card_text">{project.prj_desc_short}</p>
          </div>
        </div>
      </div></Link>
    ))}
  </div>
</div>
</Fragment>

);

}

export default ProjectsPage;
